import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); 
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      // Simulación de obtener datos de usuario usando el token
      fetchUserData(token);
      
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUserData = async (token) => {


    const data = {
        'token': token,
    };
    fetch(`${process.env.REACT_APP_API}/usercheck`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(result => {
            if (result) {
                if(result.message == "valido"){
                    console.log(result)
                    setUser(result.priv)
                    setLoading(false);
                }else{
    
                    logout();
                    setLoading(false);
                }
            } else {
                console.log(result.message);
            }
        })
        .catch(error => {
            console.log(error);
        });
  };

  const login = async (token) => {
    localStorage.setItem("token", token);
    setToken(token);
    await fetchUserData(token);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    window.location.href = "/"
    window.location.reload()
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Simulación de llamada a API para obtener datos de usuario
const fakeGetUserData = (token) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (token === "valid-token") {
        resolve({ id: 1, name: "John Doe", email: "john@example.com" });
      } else {
        reject("Invalid token");
      }
    }, 1000);
  });
};

export const useAuthContext = () => useContext(AuthContext);
